module.exports = __webpack_public_path__ + "static/media/miaou2.168bbd0f.mp3";